var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBadge',{staticClass:"versioning-badge",class:{
    'versioning-badge--is-active': _vm.isActive,
    'versioning-badge--is-dark': _vm.isDark,
  },attrs:{"id":_vm.id,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }